<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-add' class='navbarbtn' v-if='showAddPower'
        @click='showMainTableEditorDialogMD'>
        新 增
      </el-button>

      <el-button type='danger' icon='sys sys-batchdelete' class='navbarbtn' v-if='showBatchDeletePower'
        @click='batchDeleteMainTableEditor'>
        删 除
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.userName' style='width: 125px;' placeholder='用户'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.menuName' style='width: 125px;' placeholder='菜单'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :showOperationsColumn='true'
      :showExpandColumn='true' :showDefaultExpandColumn='false'
      :row-style='mainTableRowStyle'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='编辑' placement='top-start' v-if='showEditPower'>
          <el-button type='primary' circle style='padding: 4px;' @click='showMainTableEditorDialogEditMD(scope)'><i class='sys sys-edit'></i></el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletePower && scope.data.row.CanDelete === "1"'>
          <el-button type='danger' circle style='padding: 4px;' @click='deleteOneMainTableEditor(scope)'><i class='sys sys-delete'></i></el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand-tags'>
          <div class='expand-left'><span class='expand-left'>角色菜单</span></div>
          <div class='expand-right'>
            <el-button class='expand-editBtn sys sys-edit' size='mini' v-if='showSetRoleMenuPower'
              @click='showRoleMenuDialogMD(scope.data.row.detailDt2, scope.data.row.RoleCode)'>
              编辑
            </el-button>
            <span v-for='tag in scope.data.row.detailDt2' :key='tag.MenuCode'>
              <el-tag type='success' size='mini' class='expand-tag'>
                <span @click='showRoleMenuPowerDialogMD(scope.data.row.RoleCode, tag.MenuCode)'>{{tag.MenuName}}</span>
              </el-tag>
            </span>
          </div>
        </div>
        <div class='expand-tags' style='margin-top: 10px;'>
          <div class='expand-left'><span class='expand-left'>角色用户</span></div>
          <div class='expand-right'>
            <el-button class='expand-editBtn sys sys-edit' size='mini' v-if='showSetRoleUserPower'
              @click='showRoleUserDialogMD(scope.data.row.detailDt1, scope.data.row.RoleCode)'>
              编辑
            </el-button>
            <el-tag v-for='tag in scope.data.row.detailDt1' :key='tag.UserCode' size='mini'
              class='expand-tag'>
              <span>{{tag.UserName}}</span>
            </el-tag>
          </div>
        </div>
        <div class='expand-tags' style='margin-top: 10px;'>
          <div class='expand-left'><span class='expand-left'>APP权限</span></div>
          <div class='expand-right'>
            <el-button class='expand-editBtn sys sys-edit' size='mini' v-if='showSetRoleAppPowerPower'
              @click='showRoleAppPowerDialogMD(scope.data.row.detailDt3, scope.data.row.RoleCode)'>
              编辑
            </el-button>
            <el-tag v-for='tag in scope.data.row.detailDt3' :key='tag.PowerCode' size='mini'
              class='expand-tag'>
              <span>{{tag.PowerName}}</span>
            </el-tag>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog v-dialogDrag :title='mainTableEditor.editFlag ? "变更" + mainTableEditor.tableEditorInfo.TableEditorName : "添加" + mainTableEditor.tableEditorInfo.TableEditorName'
      :visible.sync='showMainTableEditorDialog'
      :width='(mainTableEditor.editFlag ? mainTableEditor.tableEditorInfo.EditWidth + 40 : mainTableEditor.tableEditorInfo.SaveWidth + 40) + "px"'
      top='10px' lock-scroll>
      <TableEditor :tableEditorFieldInfo='mainTableEditor.tableEditorFieldInfo'
        :tableEditorContent='mainTableEditor.tableEditorContent'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :style='{ "margin-top": "-20px", height: (mainTableEditor.editFlag ? mainTableEditor.tableEditorInfo.EditHeight : mainTableEditor.tableEditorInfo.SaveHeight) + "px"}'
        :tableEditorInfo='mainTableEditor.tableEditorEditorInfo' :editFlag='mainTableEditor.editFlag'>
      </TableEditor>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='saveOrEditMainTableEditor()' size='mini'>保存</el-button>
        <el-button @click='mainTableEditorReset()' size='mini'>重置</el-button>
      </div>
    </el-dialog>

    <!-- 设置角色用户弹出框 -->
    <el-dialog v-dialogDrag title='编辑角色用户' :visible.sync='showRoleUserDialog' width='696px' top='10px' lock-scroll>
      <el-transfer v-model='editRoleUser' :data='editAllUser' style='margin-top: -20px;'
        :props='{ key: "UserCode", label: "UserName" }'
        filterable :titles='["所有用户", "角色用户"]'>
      </el-transfer>
      <div class='dialogButtomBtn'>
        <el-button type='primary' @click='updateRoleUser()' size='mini'>保存</el-button>
        <el-button @click='showRoleUserDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <!-- 设置角色菜单弹出框 -->
    <el-dialog v-dialogDrag title='编辑角色菜单' :visible.sync='showRoleMenuDialog' width='696px' top='10px' lock-scroll>
      <el-transfer v-model='editRoleMenu' :data='editAllMenu' style='margin-top: -20px;'
        :props='{key: "MenuCode", label: "MenuName"}'
        filterable :titles='["所有菜单", "角色菜单"]'></el-transfer>
      <div class='dialogButtomBtn'>
        <el-button type='primary' @click='updateRoleMenu()' size='mini'>保存</el-button>
        <el-button @click='showRoleMenuDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <!-- 设置角色权限弹出框 -->
    <el-dialog v-dialogDrag title='编辑角色权限' :visible.sync='showRoleMenuPowerDialog' width='696px' top='10px' lock-scroll>
      <el-transfer v-model='editRoleMenuPower' :data='editAllMenuPower' :props='{key: "PowerCode", label: "PowerName"}'
        filterable :titles='["所有权限","角色权限"]'></el-transfer>
      <div class='dialogButtomBtn'>
        <el-button type='primary' @click='updateRoleMenuPower()' size='medium'>保存</el-button>
        <el-button @click='showRoleMenuPowerDialog = false' size='medium'>取消</el-button>
      </div>
    </el-dialog>

    <!-- 设置角色APP权限弹出框 -->
    <el-dialog v-dialogDrag title='编辑角色APP权限' :visible.sync='showRoleAppPowerDialog' width='696px' top='10px' lock-scroll>
      <el-transfer v-model='editRoleAppPower' :data='editAllAppPower' style='margin-top: -20px;'
        :props='{ key: "PowerCode", label: "PowerName" }'
        filterable :titles='["所有APP权限", "角色APP权限"]'>
      </el-transfer>
      <div class='dialogButtomBtn'>
        <el-button type='primary' @click='updateRoleAppPower()' size='mini'>保存</el-button>
        <el-button @click='showRoleAppPowerDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import tableEditor from '@/components/sys/TableEditor'
import TableEditor from '@/components/sys/TableEditor.vue'
import power from '@/components/sys/Power'
import code from '@/components/sys/Code'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'

export default {
  name: 'Role',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    TableEditor: TableEditor
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'SYS_Role',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        userName: '',
        detail2FilterStr: '',
        menuName: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],

        states: []
      },

      showMainTableEditorDialog: false,
      mainTableEditor: {
        tableEditorCode: 'SYS_Role',
        tableEditorInfo: {},
        tableEditorFieldInfo: [],
        oldTableEditorContent: {},
        tableEditorContent: {},
        editFlag: false
      },

      editRoleCode: '',

      showRoleUserDialog: false,
      editRoleUser: [],
      editAllUser: [],

      showRoleAppPowerDialog: false,
      editRoleAppPower: [],
      editAllAppPower: [],

      showRoleMenuDialog: false,
      editRoleMenu: [],
      editAllMenu: [],

      showRoleMenuPowerDialog: false,
      editRolePowerMenu: '',
      editRoleMenuPower: [],
      editAllMenuPower: [],

      showAddPower: false,
      showEditPower: false,
      showDeletePower: false,
      showBatchDeletePower: false,
      showSetRoleMenuPower: false,
      showSetRolePowerPower: false,
      showSetRoleUserPower: false,
      showSetRoleAppPowerPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.mainTable.states = code.getCode(codes, 'SYS_Role_State')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.userName) {
        const userNames = that.mainTable.userName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < userNames.length; i++) {
          detail1FilterStr += " OR UserName LIKE'%" + userNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      let detail2FilterStr = ''
      if (that.mainTable.menuName) {
        const menuNames = that.mainTable.menuName.replace(/，/g, ',').split(',')
        detail2FilterStr += ' AND (1=0 '
        for (let i = 0; i < menuNames.length; i++) {
          detail2FilterStr += " OR MenuName LIKE'%" + menuNames[i] + "%'"
        }
        detail2FilterStr += ')'
      }
      that.mainTable.detail2FilterStr = detail2FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      const that = this
      if (columnCode === 'State') {
        return that.mainTable.states
      }
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.State !== '1') {
        return { 'background-color': '#cccccc' }
      }
    },

    // 表格编辑器新增弹出框显示方法
    showMainTableEditorDialogMD: async function () {
      const that = this
      that.mainTableEditor.editFlag = false
      await tableEditor.showTableEditor(that, 'mainTableEditor')
      that.showMainTableEditorDialog = true
    },

    // 表格编辑器修改弹出框显示方法
    showMainTableEditorDialogEditMD: async function (scope) {
      const that = this
      that.mainTableEditor.oldTableEditorContent = scope.data.row
      that.mainTableEditor.editFlag = true
      await tableEditor.showTableEditor(that, 'mainTableEditor')
      that.showMainTableEditorDialog = true
    },

    // 表格编辑器新增修改弹出框数据重置方法
    mainTableEditorReset: function () {
      const that = this
      tableEditor.tableEditorReset(that, 'mainTableEditor')
    },

    // 表格编辑器数据新增修改
    saveOrEditMainTableEditor: async function () {
      const that = this
      const rtnObj = await tableEditor.saveOrEditTableEditor(that, 'mainTableEditor')
      if (!rtnObj) return
      if (rtnObj.error === '000000') {
        that.$message.success(that.mainTableEditor.editFlag ? '恭喜你，变更' + that.mainTableEditor.tableEditorInfo.TableEditorName + '成功！' : '恭喜你，新增' + that.mainTableEditor.tableEditorInfo.TableEditorName + '成功！')
        that.refreshMainTableContent()
        that.showMainTableEditorDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
    },

    // 表格编辑器数据批量删除方法
    deleteMainTableEditor: async function (selectedTableEditorContent) {
      const that = this
      for (let i = 0; i < selectedTableEditorContent.length; i++) {
        if (selectedTableEditorContent[i].CanDelete === '0') {
          that.$message.error('该角色【' + selectedTableEditorContent[i].RoleCode + '】为系统内置角色，无法删除！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await tableEditor.deleteTableEditor(that, 'mainTableEditor', selectedTableEditorContent)
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，删除' + that.mainTableEditor.tableEditorInfo.TableEditorName + '成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 表格编辑器删除某行数据确认弹出框显示方法
    deleteOneMainTableEditor: async function (scope) {
      const that = this
      await tableEditor.showTableEditor(that, 'mainTableEditor')
      that.$confirm('此操作将永久删除该' + that.mainTableEditor.tableEditorInfo.TableEditorName + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteMainTableEditor([scope.data.row])
      }).catch(() => {
      })
    },

    // 表格编辑器批量删除确认弹出框显示方法
    batchDeleteMainTableEditor: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      await tableEditor.showTableEditor(that, 'mainTableEditor')
      that.$confirm('此操作将永久删除该' + that.mainTableEditor.tableEditorInfo.TableEditorName + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.deleteMainTableEditor(that.mainTable.selections)
      }).catch(() => {
      })
    },

    // 角色用户设置弹出框显示方法
    showRoleUserDialogMD: async function (roleUsers, roleCode) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      that.editRoleCode = roleCode
      if (that.editAllUser.length <= 0) {
        const editAllUserObj = await table.getTableContent('SYS_User', 5000, 1, '', '')
        if (editAllUserObj.error === '000000') {
          that.editAllUser = editAllUserObj.tableContent
          that.editRoleUser = []
          roleUsers.forEach(roleUserOne => {
            that.editRoleUser.push(roleUserOne.UserCode)
          })
        } else {
          that.$message.error(editAllUserObj.msg)
        }
      } else {
        that.editRoleUser = []
        roleUsers.forEach(roleUserOne => {
          that.editRoleUser.push(roleUserOne.UserCode)
        })
      }
      loadingInstance.close()
      that.showRoleUserDialog = true
    },

    // 保存角色用户
    updateRoleUser: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Role.UpdateRoleUserInfo', {
        roleCode: that.editRoleCode,
        roleUser: that.editRoleUser
      })
      if (rtnObj.error === '000000') {
        that.$message.success('恭喜你，保存角色用户成功！')
        that.showRoleUserDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      that.refreshMainTableContent()
      loadingInstance.close()
    },

    // 角色菜单设置弹出框显示方法
    showRoleMenuDialogMD: async function (roleMenus, roleCode) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      that.editRoleCode = roleCode
      if (that.editAllMenu.length <= 0) {
        const editAllMenuObj = await table.getTableContent('SYS_LeafMenu', 5000, 1, ' ParentSeq ASC,Seq ASC ', '')
        if (editAllMenuObj.error === '000000') {
          that.editAllMenu = editAllMenuObj.tableContent
          that.editRoleMenu = []
          roleMenus.forEach(roleMenuOne => {
            that.editRoleMenu.push(roleMenuOne.MenuCode)
          })
        } else {
          that.$message.error(editAllMenuObj.msg)
        }
      } else {
        that.editRoleMenu = []
        roleMenus.forEach(roleMenuOne => {
          that.editRoleMenu.push(roleMenuOne.MenuCode)
        })
      }
      loadingInstance.close()
      that.showRoleMenuDialog = true
    },

    // 保存角色菜单
    updateRoleMenu: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Role.UpdateRoleMenuInfo', {
        roleCode: that.editRoleCode,
        roleMenu: that.editRoleMenu
      })
      if (rtnObj.error === '000000') {
        that.$message.success('恭喜你，保存角色菜单成功！')
        that.showRoleMenuDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      that.refreshMainTableContent()
      loadingInstance.close()
    },

    // 角色权限设置弹出框显示方法
    showRoleMenuPowerDialogMD: async function (roleCode, menuCode) {
      const that = this
      if (!that.showSetRolePowerPower) {
        return
      }
      that.editRoleCode = roleCode
      that.editRolePowerMenu = menuCode
      const loadingInstance = Loading.service({ fullscreen: true })
      let filterStr = " AND MenuCode='" + menuCode + "'"
      const editAllMenuPowerObjPromise = table.getTableContent('SYS_Power', 5000, 1, '', filterStr)
      filterStr = " AND MenuCode='" + menuCode + "' AND RoleCode='" + roleCode + "'"
      const editRoleMenuPowerObjPromise = table.getTableContent('SYS_RolePower', 5000, 1, '', filterStr)
      const editAllMenuPowerObj = await editAllMenuPowerObjPromise
      const editRoleMenuPowerObj = await editRoleMenuPowerObjPromise
      if (editAllMenuPowerObj.error === '000000') {
        that.editAllMenuPower = editAllMenuPowerObj.tableContent
      } else {
        that.$message.error(editAllMenuPowerObj.msg)
      }

      if (editRoleMenuPowerObj.error === '000000') {
        that.editRoleMenuPower = []
        editRoleMenuPowerObj.tableContent.forEach(roleMenuPowerOne => {
          that.editRoleMenuPower.push(roleMenuPowerOne.PowerCode)
        })
      } else {
        that.$message.error(editRoleMenuPowerObj.msg)
      }
      loadingInstance.close()
      that.showRoleMenuPowerDialog = true
    },

    // 保存用户权限
    updateRoleMenuPower: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Role.UpdateRoleMenuPowerInfo', {
        roleCode: that.editRoleCode,
        menuCode: that.editRolePowerMenu,
        roleMenuPower: that.editRoleMenuPower
      })
      if (rtnObj.error === '000000') {
        that.$message.success('恭喜你，保存角色权限成功！')
        that.showRoleMenuPowerDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      that.refreshMainTableContent()
      loadingInstance.close()
    },

    // 角色App权限设置弹出框显示方法
    showRoleAppPowerDialogMD: async function (roleAppPowers, roleCode) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      that.editRoleCode = roleCode
      if (that.editAllAppPower.length <= 0) {
        const editAllAppPowerObj = await table.getTableContent('SYS_AppPower', 5000, 1, '', '')
        if (editAllAppPowerObj.error === '000000') {
          that.editAllAppPower = editAllAppPowerObj.tableContent
          that.editRoleAppPower = []
          roleAppPowers.forEach(roleAppPowerOne => {
            that.editRoleAppPower.push(roleAppPowerOne.PowerCode)
          })
        } else {
          that.$message.error(editAllAppPowerObj.msg)
        }
      } else {
        that.editRoleAppPower = []
        roleAppPowers.forEach(roleAppPowerOne => {
          that.editRoleAppPower.push(roleAppPowerOne.PowerCode)
        })
      }
      loadingInstance.close()
      that.showRoleAppPowerDialog = true
    },

    // 保存角色APP权限
    updateRoleAppPower: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Role.UpdateRoleAppPowerInfo', {
        roleCode: that.editRoleCode,
        roleAppPower: that.editRoleAppPower
      })
      if (rtnObj.error === '000000') {
        that.$message.success('恭喜你，保存角色APP权限成功！')
        that.showRoleAppPowerDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      that.refreshMainTableContent()
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.dialogButtomBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.expand-tags {
  margin-left: -20px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-left {
  width: 90px;
  color: #99a9bf;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.expand-right {
  color: #000000;
  text-align: left;
}
.expand-tag {
  margin-bottom: 5px;
  margin-right: 10px;
}
.mainTag {
  background-color: rgb(255,240,245);
  color: red;
}
.expand-editBtn {
  margin-right: 10px;
  height: 25px;
  line-height: 22px;
  padding: 0px 5px;
}
.filterInput{
  margin-right: 10px;
  margin-top: 6px;
}
</style>
